/// <reference path="../../global/fn.js" />

(function ($) {
    $.widget("nsp.insightsSlider", {
        options: {
            slickOptions: {
                arrows: true,
                infinite: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
                rows: 0,
                slidesToShow: 2,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: api.vars.scr.tablet,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        },
                    },
                ],
                appendArrows: jQuery(".s-insights-slider__toolbar  .b-slick-arrows"),
            },
        },

        _create: function () {
            this.wrap = this.element.find(".s-insights-slider__cont");

            this.wrap.each((indx, el) => {
                $(el)
                    .on("init", (slick) => {})
                    .slick(this.options.slickOptions);
            });
        },
    });
})(jQuery);
